import styled from 'styled-components'
import tw from 'tailwind.macro'

const StVideoProportion = styled.div`
  position: relative;

  .heighter {
    display: block;
    height: 0;
    padding-bottom: 57%;
  }

  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
`

const StVideo = styled.div``

const StBio = styled.div`
  p {
    padding-bottom: 2rem;
    @media (max-width: 800px) {
      padding-bottom: 1rem;
    }
  }
`

const StAvatar = styled.div`
  position: relative;
  padding-bottom: 100%;
  .gatsby-image-wrapper {
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
    top: 0;
    left: 0;
  }
`

const StVideoSticky = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  &.isScrolled {
    position: fixed;
    z-index: 2;
    top: 65px;
    left: 0;
    bottom: auto;
    width: 100%;
    display: grid;
    grid-template-columns: 20% auto;
    @media (max-width: 800px) {
      grid-template-columns: repeat(2, 1fr);
    }
    align-items: center;
    grid-gap: 1rem;
    background-color: white;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);

    .video-wrapper {
      position: relative;
      padding-bottom: 57%;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .info-wrapper {
    }
  }
`

const StSep1 = styled.div`
  ${tw`border-gray-300 my-4`}
  border-bottom-width: 1px;
  border-style: solid;
`

export { StVideoProportion, StVideo, StBio, StAvatar, StVideoSticky, StSep1 }
